export default __webpack_public_path__ + "static/media/antp_ingvehicular_RicardoCortazar.865d1682.jpg";